import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (!values.adsense_publisher_id) {
    errors.adsense_publisher_id = i18n.t("Publisher ID is required");
  } else if (!values.adsense_publisher_id.match(/pub-[0-9]{16}$/)) {
    errors.adsense_publisher_id = i18n.t("Format is: pub-1234567890XXXXXX");
  }

  return errors;
};

export default validate;
